import { STORAGE_KEYS } from "src/constants/common";
import storage from "src/helpers/storage";

/**
 * Mirror native AsyncStorage key on web localStorage when RN reports hard sync success.
 * RN should send lastReadingSyncTimestampMs (or lastSyncTimestampMs) in the success payload.
 * Falls back to numeric/string timeEnd if present.
 */
export function persistLastReadingSyncTimestampFromHardSyncPayload(
  raw: unknown
): void {
  const root =
    raw && typeof raw === "object" ? (raw as Record<string, unknown>) : {};
  const inner =
    root.data && typeof root.data === "object"
      ? (root.data as Record<string, unknown>)
      : root;

  const candidates = [
    root.lastReadingSyncTimestampMs,
    root.lastSyncTimestampMs,
    inner.lastReadingSyncTimestampMs,
    inner.lastSyncTimestampMs,
  ];

  let ms: number | null = null;
  for (const c of candidates) {
    if (typeof c === "number" && !Number.isNaN(c)) {
      ms = c;
      break;
    }
    if (typeof c === "string" && /^\d+$/.test(c)) {
      ms = Number(c);
      break;
    }
  }

  if (ms == null) {
    const te = inner.timeEnd;
    if (typeof te === "number" && !Number.isNaN(te)) ms = te;
    else if (typeof te === "string" && te.length > 0) {
      const p = Date.parse(te);
      if (!Number.isNaN(p)) ms = p;
    }
  }

  if (ms != null) {
    storage.setItem(STORAGE_KEYS.CGM_LAST_READING_SYNC_TIMESTAMP, String(ms));
  }
}
